import { render, staticRenderFns } from "./ApproveButtons.vue?vue&type=template&id=3cfbd2b6&scoped=true&"
import script from "./ApproveButtons.vue?vue&type=script&lang=js&"
export * from "./ApproveButtons.vue?vue&type=script&lang=js&"
import style0 from "./ApproveButtons.vue?vue&type=style&index=0&id=3cfbd2b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfbd2b6",
  null
  
)

export default component.exports